<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-default fixed-top" id="mainNav">
        <a class="navbar-brand" style="text-align: left;" href="index.html">
            <img src="../../assets/images/tkon/tkon-white.png" data-retina="true" alt="" width="90" height="36">
        </a>
        <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav navbar-sidenav" id="exampleAccordion" style="text-align: left;">
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                    <a class="nav-link" @click="goDashboard()">
                        <i class="fa fa-fw fa-dashboard"></i>
                        <span class="nav-link-text">Dashboard</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Manajemen User Admin">
                    <a class="nav-link" @click="goUserAdmin()">
                        <i class="fa fa-fw fa-user"></i>
                        <span class="nav-link-text">Manajemen User Admin</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Manajemen Dokter">
                    <a class="nav-link" @click="goDoctor()">
                        <i class="fa fa-fw fa-user-md"></i>
                        <span class="nav-link-text">Manajemen Pakar</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Manajemen Kategori">
                    <a class="nav-link" @click="goKategori()">
                        <i class="fa fa-fw fa-list"></i>
                        <span class="nav-link-text">Manajemen Kategori</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Payment History">
                    <a class="nav-link" @click="goPaymentHistory()">
                        <i class="fa fa-fw fa-money"></i>
                        <span class="nav-link-text">History Transaction</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Payout Request">
                    <a class="nav-link" @click="goPayoutRequest()">
                        <i class="fa fa-fw fa-shopping-basket"></i>
                        <span class="nav-link-text">Payout Request</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Offline Schedule">
                    <a class="nav-link" @click="goTemuLangsung()">
                        <i class="fa fa-fw fa-handshake-o"></i>
                        <span class="nav-link-text">Offline Schedule</span>
                    </a>
                </li>
                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Subscribe Saham">
                  <a class="nav-link" @click="goSubscribeSaham()">
                    <i class="fa fa-bar-chart"></i>
                    <span class="nav-link-text">Subscribe Saham</span>
                  </a>
                </li>
            </ul>
            <ul class="navbar-nav sidenav-toggler">
                <li class="nav-item">
                    <a class="nav-link text-center" id="sidenavToggler">
                        <i class="fa fa-fw fa-angle-left"></i>
                    </a>
                </li>
            </ul>
            <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                    <a class="nav-link" data-toggle="modal" data-target="#exampleModal" @click="goLogout()">
                        Halo, <span style="font-family: Gotham-Bold;">{{ username }}</span> <i class="fa fa-fw fa-sign-out"></i>Logout
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
import store from '../../store'
const axios = require('axios')
const _ = require('lodash')

export default {
    name: 'Navbar',
    data () {
        return {
            username: store.getters.userName
        }
    },
    methods: {
        goDashboard(){ this.$router.push({name: 'Dashboard', params: { lang: this.$i18n.locale }}) },
        goUserAdmin(){ this.$router.push({name: 'ManajemenUserAdmin', params: { lang: this.$i18n.locale }}) },
        goDoctor(){ this.$router.push({name: 'ManajemenDokter', params: { lang: this.$i18n.locale }}) },
        goKategori(){ this.$router.push({name: 'ManajemenKategori', params: { lang: this.$i18n.locale }}) },
        goSubKategori(){ this.$router.push({name: 'ManajemenSubKategori', params: { lang: this.$i18n.locale }}) },
        goPaymentHistory(){ this.$router.push({name: 'PaymentHistory', params: { lang: this.$i18n.locale }}) },
        goPayoutRequest(){ this.$router.push({name: 'PayoutRequest', params: { lang: this.$i18n.locale }}) },
        goTemuLangsung(){ this.$router.push({name: 'OfflineSchedule', params: { lang: this.$i18n.locale }}) },
        goSubscribeSaham(){ this.$router.push({ name: 'SubscribeSaham', params: { lang: this.$i18n.locale } }) },
        goLogout(){
            api({
                method: 'post',
                url: config.baseApi+'/auth/logout'
            }).then(response => {
                this.$router.push({ name: 'Login', params: { lang: this.$i18n.locale } })
            }).catch(error => {
                var { response } = error
                if(response && response.data){
                    var { data } = response
                    this.$swal('Mohon maaf','Terjadi kesalahan. ' + data.message || "", 'error');
                }
            })
        },
        toogleBurger(){
			$('a.open_close').on("click", function () {
				this.burger_open = !this.burger_open
				$('.main-menu').toggleClass('show');
				$('.layer').toggleClass('layer-is-visible');
				$('header.static').toggleClass('header_sticky sticky');
				if(this.burger_open){
					$('body').addClass('body_freeze');
				} else {
					$('body').removeClass('body_freeze');
				}
			});
		},
		beforeClose(cb) {
			$('body').removeClass('body_freeze')
			cb()
		},
    }
}
</script>



// WEBPACK FOOTER //
// src/core/Admin/navbar.vue